export default __webpack_public_path__ + "static/media/Mainstreet.1cf5358f.png";